'use client'
import useSWR from 'swr'
import fetchWithTimeout from '@/lib/utils/fetch-with-timeout'

export function useUser() {
  const { data, error, isLoading } = useSWR(
    process.env.NEXT_PUBLIC_PROFILE_ROUTE || '/auth/profile',
    (...args) =>
      fetchWithTimeout(...args).then((res) => {
        if (!res.ok) {
          // throw new Error('Unauthorized')

          return null // Return null instead of throwing an error
        }
        return res.json()
      }),
    {
      // disable all automatic polling and revalidation
      refreshInterval: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  )
  // if we have the user loaded via the provider, return it
  if (data) {
    return {
      user: data,
      isLoading: false,
      error: null,
    }
  }
  if (error) {
    return {
      user: null,
      isLoading: false,
      error,
    }
  }
  return {
    user: data,
    isLoading,
    error,
  }
}
